import './App.css'
import { AboutUsPage, CareersPage, ConnectedAccountsPage, ContactPage, DeleteAccountPage, FeaturesPage, HomePage, LoginPage, PageNotFound, PricingPage, PrivacyPolicyPage, RegisterPage, TermsAndServicePage, UnifiedDashboardPage } from './pages'
import { FooterComponent, LoadingComponent, NavbarComponent } from './components'
import { BrowserRouter, Route } from 'react-router-dom'
import { Routes, useLocation } from "react-router"
import { AnimatePresence } from 'framer-motion'
import Toast from './components/NotificationComponent'
import UserState, { UserContext } from './context/UserContext'
import AccountPage from './pages/AccountPage'
import Test from './pages/Test'
import { Suspense, useContext, useEffect, useState } from 'react'
import { apiGet } from './utils/api'


const AnimatedRoutes = () => {
  const location = useLocation()
  const {userInfo} = useContext(UserContext)
  const [isDashboardAvailable, setIsDashboardAvailable] = useState(false)
  const [firstApiCallExecuted, setFirstApiCallExecuted] = useState(false)

  useEffect(()=>{
    if(userInfo?.access){
      apiGet('user-info/').then(res => {
        setIsDashboardAvailable(res?.trial?.is_trial)
        setFirstApiCallExecuted(true)
      }).catch(err => {
        console.log(err.response && err.response.data.detail ? err.response.data.detail : 'failed to get user info')
      })
    }
    else{
      console.log('first')
      setFirstApiCallExecuted(true)
    }
    const intervalId = setInterval(()=>{
      if(userInfo?.access){
        apiGet('user-info/').then(res => {
          setIsDashboardAvailable(res?.trial?.is_trial)
          setFirstApiCallExecuted(true)
        }).catch(err => {
          console.log(err.response && err.response.data.detail ? err.response.data.detail : 'failed to get user info')
        })
      }
    }, 60*1000)
    return () => {
        clearInterval(intervalId)
    }
    // eslint-disable-next-line
  },[userInfo?.access])

  const SuspenseFallBackCode = () => {
    return(
       <div className='bg-red min-h-[100vh] flex justify-center items-center flex-col'>
        <LoadingComponent className='h-10 mb-2 w-10 border-purple-500' />
        <p className='ml-3'>Loading..</p>
      </div>
    )
  }

  if(!firstApiCallExecuted){
    return(
      <SuspenseFallBackCode />
    )
  }

  
  return(
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
            <Route path='/' element={<HomePage />} />
            {isDashboardAvailable &&
              <Route path="/dashboard" element={
                <Suspense fallback={<SuspenseFallBackCode />}>
                  {userInfo?.access ? <UnifiedDashboardPage /> : <div>Not Authorized</div>}
                </Suspense>
              } />
            }
            <Route path='/features' element={<FeaturesPage />} />
            <Route path='/pricing' element={<PricingPage />} />
            <Route path='/contact' element={<ContactPage />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/register' element={<RegisterPage />} />
            <Route path='/account-page' element={<AccountPage />} />
            <Route path='/delete-account' element={<DeleteAccountPage />} />
            <Route path='/about-us' element={<AboutUsPage />} />
            <Route path='/careers' element={<CareersPage />} />
            <Route path='/connected-accounts' element={<ConnectedAccountsPage />} />
            <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
            <Route path='/terms-and-service' element={<TermsAndServicePage />} />

            {/* Testing */}
            <Route path='test' element={<Test />} />
            <Route path='*' element={<PageNotFound />} />
        </Routes>
      </AnimatePresence>
  )
}

export default function App() {
  return(
    <BrowserRouter>
      <UserState>
        <Toast />
        <NavbarComponent />
        <div className="bg-gray-50 min-h-screen font-sans pt-5">
          <AnimatedRoutes />
        </div>
        <FooterComponent />
      </UserState>
    </BrowserRouter>
  )
}